import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useBreakpointContext } from 'utils/context/BreakpointContext'

/**
 * This CancelStep component exists so the browser can navigate to a dedicated xxx/cancel url
 * that hosts it, and the mobile app that listens for url changes can close the webview and navigate accordingly.
 * The redirection in this component is mean for flows within a browser instance of Rogers.
 * This way we can just redirect from xxx/cancel to /user/settings/profile or wherever without
 * affecting the app.
 * */
export const CancelStep = () => {
  const { isMobile } = useBreakpointContext()
  const history = useHistory()
  useEffect(() => {
    if (isMobile) {
      history.push('/user/settings')
    } else {
      history.push('/user/settings/profile')
    }
  }, [history, isMobile])
  return <></>
}
